import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import * as qs from 'qs';
import { CookieService } from '../services/cookie.service';

// tslint:disable-next-line
axios.defaults.paramsSerializer = function (params: any) {
	return qs.stringify(params, { arrayFormat: 'repeat' });
};

export default axios;

// tslint:disable-next-line
axios.interceptors.response.use(
	function (response: AxiosResponse<any>) {
		return response;
		// tslint:disable-next-line
	},
	function (error: any) {
		// Do something with response error
		if (
			error.response.status === 401 &&
			!error.config?.url?.includes('/api/auth/logout') && // CRITICAL: Exclude logout
			!error.config?.url?.includes('/auth/logout') && // Both logout endpoints
			!window.location.href.includes('core?r=site/login') &&
			!window.location.href.includes('core?r=users/sessions') &&
			!window.location.href.includes('app/users/interstitial') // Safety net
		) {
			const currentPath = window.location.pathname + window.location.search;
			// Redirect to React interstitial instead of PHP login
			return (window.location.href = `/app/users/interstitial?redirect=${encodeURIComponent(currentPath)}`);
		}
		return Promise.reject(error);
	}
);

// tslint:disable-next-line
axios.interceptors.request.use(function (config: InternalAxiosRequestConfig) {
	if (['delete', 'post', 'patch', 'put'].includes(config.method)) {
		// Hapi API routes use /api prefix and expect SOS_CSRF_TOKEN
		// Yii routes expect YII_CSRF_TOKEN
		const isHapiRoute = config.url?.startsWith('/api');
		const sosCsrfToken = CookieService.get('SOS_CSRF_TOKEN');
		const yiiCsrfToken = CookieService.get('YII_CSRF_TOKEN');

		if (isHapiRoute && sosCsrfToken) {
			config.headers['X-CSRF-Token'] = encodeURIComponent(sosCsrfToken);
		} else if (yiiCsrfToken) {
			config.headers['X-CSRF-Token'] = encodeURIComponent(yiiCsrfToken);
		}
	}

	return config;
});
